import brandsApiFactory from '../../modules/brands/brandsApi';

/* Actions */
import {
  getBrandsActionCreators,
} from '../actions/brandsActions';

/* Utils */
import {
  generateDefaultAsyncSaga,
  generateDefaultAsyncWatcher,
} from '../core/reduxUtils';

function brandsSagasFactory({storefrontApiClient}) {
  const brandsApi = brandsApiFactory(storefrontApiClient);
  const getBrandsSagas = generateDefaultAsyncSaga(
    brandsApi.getBrands,
    getBrandsActionCreators,
    payload => [
      payload.params,
    ]
  );

  const watchGetBrandss = generateDefaultAsyncWatcher(
    'GET_BRANDS',
    getBrandsSagas
  );

  const brandsSagas = [
    watchGetBrandss(),
  ];

  return brandsSagas;
}

export default brandsSagasFactory;
